import { getMsalState } from './msalPlugin'

export const permissionNames = Object.freeze({
  driveparkAccess: 'drivepark.access',
  eventsAccess: 'events.access',
  eventsActivityStart: 'events.activity-start',
  eventsCandidatesAccess: 'events.candidates-access',
  eventsDocumentsDownload: 'events.documents-download',
  eventsDocumentsSign: 'events.documents-sign',
  eventsEdit: 'events.edit',
  eventsInviteesAccess: 'events.invitees-access',
  eventsInviteesEdit: 'events.invitees-edit',
  eventsInviteesImport: 'events.invitees-import',
  eventsInviteesQrDownload: 'events.invitees-qr-download',
})

export function hasPermission (permission) {
  return getMsalState()?.permissions?.permissions.includes(permission) ?? false
}

export function hasAllPermissions (permissions) {
  return permissions.every(hasPermission)
}

export function canAccessBrand (brandCode) {
  const limitedBrandCodes = getMsalState()?.permissions?.limitedBrandCodes ?? []
  return limitedBrandCodes.length === 0 || limitedBrandCodes.includes(brandCode)
}
